/** Recent searches are remembered on the device and offered when the search field is focused. */

const KEY = 'gymcloud.recent-searches'
const LIMIT = 8

export function loadRecentSearches(): string[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (raw === null) {
      return []
    }
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((term) => typeof term === 'string') : []
  } catch {
    return []
  }
}

export function saveRecentSearch(term: string): void {
  const trimmed = term.trim()
  if (trimmed === '') {
    return
  }
  const kept = loadRecentSearches().filter(
    (candidate) => candidate.toLowerCase() !== trimmed.toLowerCase(),
  )
  try {
    localStorage.setItem(KEY, JSON.stringify([trimmed, ...kept].slice(0, LIMIT)))
  } catch {
    // Storage full or unavailable — search history is a nicety, not a requirement.
  }
}
